export const name = {
    'en': "Speech to Text",
    'zh-tw': "語音轉文字"
};

export const voicetoTEXT = {
    'en': "transcribed text",
    'zh-tw': "語音文字"
};

export const pauseVoice = {
    'en': "pause speech to text",
    'zh-tw': "暫停語音辨識"
};

export const nullTEXT = {
    'en': "clear transcribed text",
    'zh-tw': "清除語音文字"
};

export const beginVoice = {
    'en': "launch speech to text",
    'zh-tw': "語音辨識開始"
};

export const lang_List = {
    'en': ['cmn-Hant-TW','en-US','ja-JP','ko-KR','cmn-Hans-CN','yue-Hant-HK'],
    'zh-tw': ['繁中文','English','日文','한국어','简中文','粵語'],
};

export const setLang ={
    'en': "Lang set [LANG]",
    'zh-tw': "語音設為[LANG]"
}